import LiveSearchRequest from './LiveSearchRequest.js';
import scrollBar from './ScrollBar.js';

// позволяет выполнять переданную функцию не чаще 1 раза в заданный интервал времени
function debounce(fn, delay) {
  var timer = null;

  return function () {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
    fn.apply(context, args);
    }, delay);
  };
}

/**
* Поиск товаров
*/
class LiveSearch {

  /**
   * 
   */
  constructor() {
    this.search = document.querySelector(".live-search");
    this.searchForm = document.querySelector(".live-search-box");
    this.searchField = document.querySelector(".live-search-box__input");
    this.closeBtn = document.querySelector(".live-search-box__close");
    this.searchMessage = document.querySelector(".live-search__message");
    this.searchResults = document.querySelector(".live-search__results");
   
    this.setHandlers();
   }

  setHandlers() {
    this.request = new LiveSearchRequest(this.onSuccess.bind(this), this.onError.bind(this));
    this.searchForm.addEventListener('keydown', this.preventSubmit);
    this.closeBtn.addEventListener('click', this.hide.bind(this));
    document.addEventListener('keydown', this.closeByEscapeHandler.bind(this));

    const keyUpHandler = debounce(this.keyUpHandler, 200).bind(this);
    this.searchField.addEventListener('keyup', keyUpHandler);
  }

  // обработка данных, полученных с сервера, при успехе
  onSuccess(data) {
    // console.log(data);
    this.showResults(data);
  };
  
  // обработка ошибок при получении данных с сервера
  onError(message) {
    // console.log(message);
    this.showMessage('Произошла ошибка при выполнении запроса. Извините за временные неудобства.', true);
  };
  
  // запрет отправки формы поиска при вводе enter в элементе ввода
  preventSubmit(event) {
    if(event.keyCode == 13) {
    event.preventDefault();
    return false;
    }
  }
  
  // отображает переданное сообщение
  showMessage(message, hasErrors = false) {
    this.searchResults.innerHTML = '';
    this.searchMessage.innerHTML = message;
    (hasErrors) ?
      this.searchMessage.classList.add('live-search__message--error') :
      this.searchMessage.classList.remove('live-search__message--error');
  }
  
  // отображает переданные данные
  showResults(data) {
    this.searchMessage.classList.remove('live-search__message--error');
    this.searchMessage.innerHTML = 'Найдено товаров - ' + data.length;
    this.searchResults.innerHTML = '';

    // data.forEach((product) => {
    //   const li = document.createElement('li');
    //   li.innerHTML = `${product.title}  || <i>Артикул:</i> ${product.art}`;
    //   this.searchResults.appendChild(li);
    // });


    data.forEach((product) => {
      const li = document.createElement('li');
      li.className = 'live-search-result';

      const template = `
        <div class="live-search-result__thumb">
          <a class="live-search-result__link" href="${product.href}">
            <img src="${product.thumb}" alt="${product.title}"/>
          </a>
        </div>            
        <div class="live-search-result__body">
          <div class="live-search-result__title">
            <a class="live-search-result__link" href="${product.href}">${product.title}</a>
          </div>
          <div class="live-search-result__description">
            <a class="live-search-result__link" href="${product.href}">${product.description}</a>
          </div>
        </div>
      `;

      li.innerHTML = template;
      this.searchResults.appendChild(li);
    });



  }

  // устанавливает элементы поиска в начальное состояние
  setInitialState() {
    this.request.cancel();
    this.showMessage('Начинайте вводить запрос в поле выше.');
  }
  
  // показывает функционал поиска
  show() {
    scrollBar.hide();
    this.search.classList.add('live-search--visible');
    this.searchField.focus();
  }

  // скрывает функционал поиска
  hide() { 
    scrollBar.show();
    this.searchField.blur();
    this.search.classList.remove('live-search--visible');  
  }

  isVisible() { 
    return this.search.classList.contains('live-search--visible');  
  }

  // обработчик ввода символов в поле поиска 
  keyUpHandler() {
    const what = this.searchField.value;
    // console.log(what);
    if (what.length == 0) {
      this.setInitialState();
      return;
    }
    if (what.length > 0) {
      this.request.search(what);
    }
  }

  // сокрытие функционала поиска по ESC
  closeByEscapeHandler(e) {
    if ((e.keyCode == 27) && this.isVisible()) {
      this.hide();
      e.preventDefault();	
      return;
     }
  }
  
}

export default LiveSearch;